import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const ScheduleCall = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    units: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [submitError, setSubmitError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    // Clear messages when user starts typing
    if (submitMessage || submitError) {
      setSubmitMessage('');
      setSubmitError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');
    setSubmitMessage('');

    try {
      // Determine API URL based on environment
      const apiUrl = process.env.NODE_ENV === 'production' 
        ? '/api/schedule-call'  // Relative URL for same domain
        : 'http://localhost:5000/api/schedule-call';  // Local development

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setSubmitMessage(data.message || 'Thank you! We will contact you soon.');
        // Reset form
        setFormData({
          name: '',
          email: '',
          company: '',
          phone: '',
          units: '',
          message: ''
        });
        // Optionally redirect after a delay
        setTimeout(() => {
          navigate('/');
        }, 3000);
      } else {
        setSubmitError(data.error || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitError('Network error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="schedule-call-page">
      {/* Header */}
      <div className="schedule-call-header">
        <button 
          className="schedule-call-back-btn"
          onClick={() => navigate('/')}
        >
          ← Back
        </button>
        <h1 className="schedule-call-title">Schedule a Call</h1>
        <p className="schedule-call-subtitle">
          Let's discuss how CaptiveWorks can help transform your compliance into a profit center.
        </p>
      </div>

      {/* Form Section */}
      <div className="schedule-call-form-wrapper">
        <form className="schedule-call-form" onSubmit={handleSubmit}>
          <div className="schedule-call-form-row">
            <div className="schedule-call-form-group">
              <label htmlFor="name" className="schedule-call-label">Full Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                className="schedule-call-input"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="schedule-call-form-group">
              <label htmlFor="email" className="schedule-call-label">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                className="schedule-call-input"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="schedule-call-form-row">
            <div className="schedule-call-form-group">
              <label htmlFor="company" className="schedule-call-label">Company Name</label>
              <input
                type="text"
                id="company"
                name="company"
                className="schedule-call-input"
                value={formData.company}
                onChange={handleChange}
              />
            </div>
            <div className="schedule-call-form-group">
              <label htmlFor="phone" className="schedule-call-label">Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                className="schedule-call-input"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="schedule-call-form-group">
            <label htmlFor="units" className="schedule-call-label">Number of Units</label>
            <input
              type="number"
              id="units"
              name="units"
              className="schedule-call-input"
              value={formData.units}
              onChange={handleChange}
              placeholder="e.g., 5000"
            />
          </div>

          <div className="schedule-call-form-group">
            <label htmlFor="message" className="schedule-call-label">Message (Optional)</label>
            <textarea
              id="message"
              name="message"
              className="schedule-call-textarea"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              placeholder="Tell us about your needs..."
            />
          </div>

          {submitMessage && (
            <div className="schedule-call-message schedule-call-success">
              {submitMessage}
            </div>
          )}
          {submitError && (
            <div className="schedule-call-message schedule-call-error">
              {submitError}
            </div>
          )}
          <button 
            type="submit" 
            className="schedule-call-submit-btn"
            disabled={isSubmitting}
          >
            <span>{isSubmitting ? 'Submitting...' : 'Schedule a Call'}</span>
            {!isSubmitting && <span className="arrow-icon">↗</span>}
          </button>
        </form>
      </div>

      {/* Footer */}
      <div className="schedule-call-footer">
        <p className="schedule-call-footer-text">
          By submitting this form, you agree to be contacted by CaptiveWorks.
        </p>
        <div className="schedule-call-footer-links">
          <Link to="/" className="schedule-call-footer-link">Home</Link>
          <a href="#terms" className="schedule-call-footer-link">Terms of Service</a>
          <a href="#privacy" className="schedule-call-footer-link">Privacy Policy</a>
        </div>
        <p className="schedule-call-footer-copy">
          &copy; 2025 Captiveworks. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default ScheduleCall;

